import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "p-text-center p-my-0" }, "Erreurs d'importation du fichier", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      label: _ctx.label,
      class: "p-button-success p-button-outlined p-button-rounded",
      icon: "pi pi-info-circle",
      onClick: _ctx.showErrors
    }, null, 8, ["label", "onClick"]),
    (_ctx.errors.length)
      ? (_openBlock(), _createBlock(_component_OverlayPanel, {
          key: 0,
          ref: "importation_op",
          appendTo: "body",
          showCloseIcon: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              value: _ctx.errors,
              rows: _ctx.errors.length
            }, {
              header: _withCtx(() => [
                _hoisted_1
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "row",
                  header: "N°Ligne"
                }),
                _createVNode(_component_Column, {
                  field: "reason",
                  header: "Raison"
                })
              ]),
              _: 1
            }, 8, ["value", "rows"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 64))
}